var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(170,170,170,0.5)"
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view === "list",
              expression: "view==='list'"
            }
          ],
          staticClass: "grid-view"
        },
        [
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c("div", { staticClass: "section operations" }, [
                _c(
                  "div",
                  { staticClass: "triggers" },
                  [
                    _c(
                      "search-item",
                      {
                        attrs: {
                          "config-module": "2800",
                          reset: true,
                          "custom-search-items": _vm.customSearchItems,
                          "custom-sim-query-placeholder": _vm.$t(
                            "Message.PleaseEnterTheWarehouseNumber"
                          )
                        },
                        on: {
                          "click-more": function(value) {
                            return (_vm.isAdvancedQuery = value)
                          },
                          simSearchItemCallBack: _vm.toSimpleQuery,
                          advSearchItemCallBack: _vm.toAdvancedQuery
                        }
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "operations" }, slot: "operations" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.inWarehouseHandler }
                              },
                              [_vm._v(_vm._s(_vm.$t("queryJob.warehousing")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: _vm.rowData.length === 0,
                                  no: "print",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onPrintHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                            ),
                            _c(
                              "el-select",
                              {
                                staticStyle: {
                                  width: "100px",
                                  "padding-left": "5px"
                                },
                                on: { change: _vm.onTimeRangeChange },
                                model: {
                                  value: _vm.timeRange,
                                  callback: function($$v) {
                                    _vm.timeRange = $$v
                                  },
                                  expression: "timeRange"
                                }
                              },
                              _vm._l(_vm.TIME_RANGES, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.chineseName,
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            ),
                            _c("el-date-picker", {
                              staticStyle: { width: "120px", margin: "0 5px" },
                              attrs: {
                                disabled: _vm.timeRange !== _vm.CUSTOM.code,
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                editable: false,
                                clearable: false
                              },
                              model: {
                                value:
                                  _vm.filter.estimatedDateOfWarehousingeStart,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filter,
                                    "estimatedDateOfWarehousingeStart",
                                    $$v
                                  )
                                },
                                expression:
                                  "filter.estimatedDateOfWarehousingeStart"
                              }
                            }),
                            _vm._v("- "),
                            _c("el-date-picker", {
                              staticStyle: {
                                width: "120px",
                                "margin-left": "5px"
                              },
                              attrs: {
                                disabled: _vm.timeRange !== _vm.CUSTOM.code,
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                editable: false,
                                clearable: false
                              },
                              model: {
                                value:
                                  _vm.filter.estimatedDateOfWarehousingeEnd,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filter,
                                    "estimatedDateOfWarehousingeEnd",
                                    $$v
                                  )
                                },
                                expression:
                                  "filter.estimatedDateOfWarehousingeEnd"
                              }
                            }),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { margin: "0 5px" },
                                on: { change: _vm.resetTimer },
                                model: {
                                  value: _vm.autoRefresh,
                                  callback: function($$v) {
                                    _vm.autoRefresh = $$v
                                  },
                                  expression: "autoRefresh"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.AutomaticallyRefresh")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c("cargo-ag-grid", {
                staticClass: "section grid-wrapper",
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      !_vm.stayWarehousingNew
        ? _c("tab-form", {
            attrs: {
              visible: _vm.view === "detail" && !_vm.stayWarehousingNew,
              job: _vm.tabForm.job
            },
            on: { back: _vm.backToList }
          })
        : _vm._e(),
      _c("warehousing-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail" && _vm.stayWarehousingNew,
            expression: "view==='detail' && stayWarehousingNew"
          }
        ],
        ref: "warehousingWorkspace",
        attrs: { "parent-context": _vm.context, lob: "AE" },
        on: { back: _vm.backToList, refresh: _vm.refreshHandle }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }